import './OrderResultPage.less';

export const prefix = 'oc-p-order-result';

export { default } from './OrderResultPage';